module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tradeelite"
  }, [_c('div', {
    staticClass: "header_screen container_wrap br10"
  }, [_c('div', {
    staticClass: "header_screen_item"
  }, [_c('div', {
    staticClass: "header_screen_item_title"
  }, [_vm._v("类型")]), _vm._v(" "), _c('div', {
    staticClass: "header_screen_item_els"
  }, _vm._l((_vm.catelist), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < 2),
        expression: "index<2"
      }],
      key: index,
      staticClass: "header_screen_item_el",
      class: item.class,
      on: {
        "click": function($event) {
          return _vm.handleNavClick(index, item, _vm.catelist)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "star_list container_wrap"
  }, _vm._l((_vm.personinf), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "star_list_item_wrap"
    }, [_c('div', {
      staticClass: "star_list_item"
    }, [_c('div', {
      staticClass: "star_list_item_pic"
    }, [_c('img', {
      attrs: {
        "src": item.pics[0].url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_right"
    }, [_c('div', {
      staticClass: "star_list_item_right_name"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_right_des"
    }, [_vm._v(_vm._s(item.desc))]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_right_star"
    }, [_vm._v(_vm._s(_vm._f("filterOne")(item.cate_ids)))])])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-150335c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/TradeElite.vue
// module id = 1326
// module chunks = 0